import { db, ensureAuth } from './firebase';
import { addDoc, collection, Timestamp } from 'firebase/firestore';
import type { VendorPortalActivityType } from '../types';

const SESSION_ID = crypto.randomUUID
  ? crypto.randomUUID()
  : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

export async function logVendorPortalActivity(
  supplierOrgId: string,
  type: VendorPortalActivityType,
  action: string,
  opts?: {
    rfqProjectId?: string | null;
    rfqPackageId?: string | null;
    metadata?: Record<string, unknown>;
    source?: 'vendor' | 'employee';
  },
): Promise<void> {
  if (!supplierOrgId) return;
  try {
    await ensureAuth();
    await addDoc(collection(db, 'vendorPortalActivity'), {
      supplierOrgId,
      rfqProjectId: opts?.rfqProjectId ?? null,
      rfqPackageId: opts?.rfqPackageId ?? null,
      sessionId: SESSION_ID,
      type,
      action,
      metadata: opts?.metadata ?? null,
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
      source: opts?.source ?? 'vendor',
      timestamp: Timestamp.now(),
    });
  } catch (err) {
    console.warn('[VendorActivity] Failed to log:', action, err);
  }
}
